const Name = cell => {
  return cell.value ? cell.value : ""
}

const VendorType = cell => {
  return cell.value ? cell.value : ""
}
const Ceremony = cell => {
  return cell.value ? cell.value : "All events"
}
const Unit = cell => {
  return cell.value ? cell.value : ""
}

const Value = cell => {
  return cell.value ? cell.value : ""
}

export { Ceremony, Name, VendorType, Unit, Value }
